import { render, staticRenderFns } from "./PhotosModal.vue?vue&type=template&id=3d99f0da&scoped=true&"
import script from "./PhotosModal.vue?vue&type=script&lang=js&"
export * from "./PhotosModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotosModal.vue?vue&type=style&index=0&id=3d99f0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d99f0da",
  null
  
)

export default component.exports